export default __webpack_public_path__ + "static/media/linkedin-24-px.12aa8f0f.svg";